import axios from "axios";
import { toast } from "react-toastify";

const requestInstance = axios.create();

let token = localStorage.getItem("token") || "";

requestInstance.interceptors.request.use(
  (config) => {
    token = localStorage.getItem("token") || "";
    if (token) {
      if (config.method === "patch" || config.method === "post") {
        // Only set form-urlencoded if JSON is not explicitly set
        const currentContentType = config.headers["Content-Type"];
        if (currentContentType !== "application/json") {
          config.headers = {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          };
        } else {
          config.headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          };
        }
      } else {
        config.headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        };
      }
    } else {
      config.headers = {
        "Content-Type": "application/json",
      };
    }

    return config;
  },
  (error) => {
    toast.error(error);
    return Promise.reject(error);
  }
);

// Add a response interceptor
requestInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error?.response?.status === 403 || error?.response?.status === 401) {
      localStorage.clear();
      window.location.pathname = "/login";
    }
    return Promise.reject(error);
  }
);

export default requestInstance;
